// import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import modal from 'ant-design-vue/es/modal'
import i18n from '@/i18n/i18n'
// import { USER_INFO } from '@/store/mutation-types'
// import ipConfig from '../../config/ip.config'
import Cookies from 'js-cookie'
const HttpStatusCode = {
  SUCCESS: 200,
  CLIENTERROR: 400,
  AUTHENTICATE: 401,
  FORBIDDEN: 403,
  NOTFOUND: 404,
  SERVERERROR: 500,
  BADGATEWAY: 502,
  SERVICEUNAVAILABLE: 503,
  GATEWAYTIMEOUT: 504
}

message.config({
  top: `100px`,
  maxCount: 3
})

const HttpResponseCode = {
  SUCCESS: '00000000',
  TOKENERROR: '10001701',
  TOKENERROR2: '00000401',
  SERVERERROR: '00000500',
  TOKEN_EXPIRE: '000000607',
  TOKEN_FAILURE: '000000608'
}

// 基础请求类：httpClient
const httpClient = axios.create({
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 60000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

httpClient.interceptors.request.use(config => {
  config.headers.appCode = 'PUDS'
  // const token = Cookies.get('MW_USERCENTER_TOKEN') || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyMDE4MDgwMTQ5MjQiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoi5aSn6YeR5YyW5a2m5Zu96ZmF6LS45piT77yI5LiK5rW377yJ5pyJ6ZmQ5YWs5Y-4IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbW9iaWxlcGhvbmUiOiIiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9lbWFpbGFkZHJlc3MiOiJkaW5nLmxpbkBkYWlraW4ubmV0LmNuIiwiaWF0IjoiMTc1NDQ0NjUyMyIsIm5iZiI6IjE3NTQ0NDY1MjMiLCJleHAiOiIxNzU0NTMyOTIzIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9leHBpcmF0aW9uIjoiMjAyNS84LzcgMTA6MTU6MjMiLCJpc3MiOiJtd2NsZ0N1c3RvbWVyQWNjb3VudFNlbGVjdCIsImF1ZCI6ImFwaWdldFRva2VuIn0.zdMSNPEKxkNMS1w5piYP1sTBKWagAkep3dCVjdv9XL8'
  // const userInfo = JSON.parse(Cookies.get('MW_USERCENTER_INFO') || '{"CACode":"201808014924","CAName":"大金化学国际贸易（上海）有限公司","CANameEn":"Daikin Chemical International Trading (Shanghai) Co., Ltd.","CAEmail":"ding.lin@daikin.net.cn","MenuList":["Dashboard","Tracking","OceanFreight","AirFreight","RailwayFreight","Trucking","Warehousing","TankService","Invoice","Agreement"]}')

  const token = Cookies.get('MW_USERCENTER_TOKEN') || ''
  const userInfo = Cookies.get('MW_USERCENTER_INFO') ? JSON.parse(Cookies.get('MW_USERCENTER_INFO')) : ''
  if (token || config.noToken) {
    config.headers.Authorization = 'Bearer ' + token
    config.headers.token = token
    config.headers.CustomerID = userInfo ? userInfo.CACode : ''
    const lang = localStorage.getItem('pro__lang') ? JSON.parse(localStorage.getItem('pro__lang')) : { value: 'zh' }
    if(lang){
        config.headers.lang = lang.value || 'zh'
    }
  } else {
    handleTokenError()
  }
  // throw new Error('登录失效，请重新登录')
  return config
}, err => {
  return Promise.reject(err)
})

httpClient.interceptors.response.use(response => {
  if (response.request.responseType === 'blob') {
    if (response.data.type === 'application/pdf' && response.request.responseURL.indexOf('previewpdf') !== -1) {
      return Promise.resolve(response)
    }
    // console.log(response)
    let contentDisposition = ''
    let name = ''
    if (response.config.fileName) {
      name = response.config.fileName
    } else {
      contentDisposition = response.headers['content-disposition']
      name = contentDisposition.substring(contentDisposition.indexOf('filename=') + 9, contentDisposition.length)
    }
    const link = document.createElement('a')
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    link.setAttribute('download', decodeURIComponent(name))
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  return Promise.resolve(response)
}, error => {
  return Promise.resolve(error.response)
})

// 业务请求类：httpService
const httpService = (option) => {
  const params = Object.assign({}, option.params)
  const data = Object.assign({}, option.data)
  option.params = params
  option.data = data
  return new Promise((resolve, reject) => {
    const config = option
    httpClient(config).then(res => {
      handleResponse(res, resolve, reject)
    })
  })
}

const handleResponse = (response, resolve, reject) => {
  if (!response) {
    reject()
    handleErrorWithHttpResponseData({ code: 500 })
    return
  }
  if (response.status === HttpStatusCode.SUCCESS) {
    const responseData = response.data
    if (responseData.code === HttpResponseCode.SUCCESS || responseData.Code === 200 || responseData.ErrorCode === 200 || responseData.code == 200) {
      resolve(responseData)
    } else if ([HttpResponseCode.TOKEN_EXPIRE, HttpResponseCode.TOKEN_FAILURE].includes(responseData.code) || responseData.ErrorCode === 401) {
      modal.warning({
        title: i18n.t('ChangePassword.Prompt'),
        content: i18n.t('ChangePassword.LoginInvalid'),
        closable: false,
        keyboard: false,
        maskClosable: false,
        okText: i18n.t('ServiceEvaluation.Confirm'),
        onOk() {
          // window.location.href = ipConfig.LOGINURL
        }
      })
    } else if (response.request.responseType === 'blob') {
      resolve('file start downloading')
    } else {
      reject()
      handleErrorWithHttpResponseData(responseData)
    }
  } else {
    if (response.ErrorCode === 401) {
      modal.warning({
        title: i18n.t('ChangePassword.Prompt'),
        content: i18n.t('ChangePassword.LoginInvalid'),
        closable: false,
        keyboard: false,
        maskClosable: false,
        okText: i18n.t('ServiceEvaluation.Confirm'),
        onOk() {
          // window.location.href = ipConfig.LOGINURL
        }
      })
    }
    reject()
    handleErrorWithHttpResponse(response)
  }
}

// 处理response错误
const handleErrorWithHttpResponse = (response) => {
  if (response.status === HttpStatusCode.AUTHENTICATE) {
    handleTokenError()
  } else {
    if (response.data && response.data.message) {
      notification.error({
        message: i18n.t('ChangePassword.error'),
        description: response.data.message
      })
    } else if(responseData.message || responseData.msg || responseData.Message){
        setTimeout(() => {
            message.error(responseData.message || responseData.msg || responseData.Message)
        })
    } else {
      notification.error({
        message: i18n.t('ChangePassword.error'),
        description: 'Sorry!'
      })
    }
  }
}

// 处理response.data错误
const handleErrorWithHttpResponseData = (responseData) => {
  if (responseData.code === HttpResponseCode.TOKENERROR || responseData.code === HttpResponseCode.TOKENERROR2) {
    handleTokenError()
  } else {
    if (responseData.message || responseData.msg || responseData.Message) {
      setTimeout(() => {
        message.error(responseData.message || responseData.msg || responseData.Message)
      })
    }
  }
}

// 未授权 token出错操作
const handleTokenError = async () => {
  await store.dispatch('user/logout').then(() => {
    setTimeout(() => {
      window.location.reload()
    }, 1500)
  })
}

export {
  httpService as axios,
  HttpResponseCode
}
